package com.wintermar.inspection.feature.presentation.inspection.landing.widget

import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import com.wintermar.inspection.core.ui.theme.AppDimension
import com.wintermar.inspection.core.ui.theme.LocalAppTheme
import com.wintermar.inspection.core.ui.widget.CircularProgress
import com.wintermar.inspection.core.ui.widget.IconText
import com.wintermar.inspection.feature.domain.model.inspection.InspectionModel
import com.wintermar.inspection.feature.util.inspection_status.InspectionStatusView
import com.wintermar.inspection.graphql.type.InspectionStatus
import inspection.composeapp.generated.resources.Res
import inspection.composeapp.generated.resources.delete
import inspection.composeapp.generated.resources.ic_trash
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.stringResource

@Composable
fun InspectionLandingMoreActionContent(
    data: InspectionModel?,
    onDelete: () -> Unit
) {
    val dimension = LocalAppTheme.current.dimension
    val color = LocalAppTheme.current.color

    Row(
        modifier = Modifier
            .fillMaxWidth()
            .background(color.surface.brand.primarySubtle.default)
            .padding(dimension.spacing.space4),
        horizontalArrangement = Arrangement.spacedBy(
            dimension.spacing.space2
        ),
        verticalAlignment = Alignment.Top
    ) {
        Column(modifier = Modifier.weight(1f).align(Alignment.CenterVertically)) {
            InspectionLandingContentItem(
                templateName = data?.templateName ?: "",
                vesselName = data?.vesselName ?: "",
                lastUpdateIso = data?.lastUpdated ?: "",
            )
        }

        Column(
            verticalArrangement = Arrangement.spacedBy(
                dimension.spacing.space2
            )
        ) {
            InspectionStatusView(data?.status ?: InspectionStatus.UNKNOWN__)
            CircularProgress(
                progress = data?.totalAnswer ?: 0,
                total = data?.totalQuestion ?: 0
            )
        }
    }
    Spacer(modifier = Modifier.height(dimension.spacing.space2))

    ClickableItem(
        label = stringResource(Res.string.delete),
        icon = Res.drawable.ic_trash,
        tint = color.icon.error.default,
        onClick = {
            onDelete()
        }
    )
    Spacer(modifier = Modifier.height(dimension.spacing.space2))
}

@Composable
private fun ClickableItem(
    label: String,
    icon: DrawableResource,
    dimension: AppDimension = LocalAppTheme.current.dimension,
    tint: Color = LocalAppTheme.current.color.icon.subtle,
    onClick: () -> Unit
) {
    Row(
        modifier = Modifier
            .fillMaxWidth()
            .clickable {
                onClick()
            }
            .padding(
                horizontal = dimension.spacing.space4,
                vertical = dimension.spacing.space2
            )
    ) {
        IconText(
            icon = icon,
            text = label,
            tint = tint,
            iconSize = dimension.size.icon.s
        )
    }
}

@Composable
expect fun InspectionLandingMoreActionModal(
    show: Boolean,
    onDismiss: () -> Unit,
    content: @Composable () -> Unit
)
